
import { createStyles, makeStyles, withStyles } from '@material-ui/core';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { OrganogramModel } from '../../Models/OrganogramModel';
import { theme } from '../../theme';

export interface IOrganogramAccordionItemProps {
    organogram: OrganogramModel, 
    textLevel: string, 
    isParent: boolean, 
    level: number, 
    listOrg: OrganogramModel[]
}

export const organogramAccordionStyles = makeStyles(() => createStyles({
    notClickableAccordion: {
        cursor: 'default !important',
        fontWeight: 'normal'
    },    
}));


export const OrganogramAccordion = withStyles({
    root: {
        boxShadow: 'none',
        margin: '0px 0',        
    },    
})(MuiAccordion);
  
export const OrganogramAccordionSummary = withStyles({
    root: {
        margin: '0px 0',
        maxHeight: theme.spacing(4),
        '&$expanded': {
            minHeight: theme.spacing(6),
        },
    },
    content: {
        '&$expanded': {
        },
    },        
})(MuiAccordionSummary);